import { prop } from '@rxweb/reactive-form-validators';
import { PersonType } from '../enums/person-type.enum';

export class InvitationRegister {
  public constructor(init?: Partial<InvitationRegister>) {
    Object.assign(this, init);
  }
  id: string;
  socialNumber: string;
  email: string;
  check: boolean;
  isExternal: boolean;
  reSendInvite: boolean;
  madeByRepresentative: boolean;
  representative: Representative;
  type: string;
  isEscrow: boolean;
  distributor: Distributor;
  services: string[];
}

export class Representative {
  email: string;
  socialNumber: string;
}
export class Distributor {
  @prop()
  distributorPersona = '';

  constructor(persona?: PersonType) {
    this.distributorPersona = persona;
  }

  @prop({ ignore: (entity) => entity.distributorPersona !== PersonType.Juridica && entity.distributorPersona !== PersonType.PJInvestidor })
  name: string;

  @prop({ ignore: (entity) => entity.distributorPersona !== PersonType.Juridica && entity.distributorPersona !== PersonType.PJInvestidor })
  document: string;
}
